import React, { Component } from 'react';
import Card from 'components/Card/Card';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import CardBody from 'components/Card/CardBody';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { dominioDemandaCirurgica } from '../../config/database';
import 'assets/css/anotacao.css';

class Anotacao extends Component {
  state = {
    anotacoes: [],
    globalFilter: null,
    first: 0,
    loading: false,
    selectedDateInclusao: null,
  };

  visualizarAnotacoes = () => {
    this.state.anotacoes.map(anotacao => {
      if(anotacao.dataVisualizacao == null){
        dominioDemandaCirurgica
        .put(`/api/visualizaAnotacao/${anotacao.id}`);
      }
    });
  };

  listarAnotacoes = () => {
    this.setState({ loading: true });
    dominioDemandaCirurgica
      .get(`/api/anotacaoDemandaDetail/${this.props.demanda}`)
      .then(response => {
        this.setState({
          anotacoes: response.data,
          loading: false,
        });        
      }).then(() =>{        
        this.visualizarAnotacoes();
      });
  };

  componentDidMount() {
    this.listarAnotacoes();
  }

  anotacaoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Anotação</span>
        <span>
          <p>{rowData.anotacao}</p>
        </span>
      </>
    );
  };

  dataBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Data</span>
        <span>{new Date(rowData.dataInclusao).toLocaleString()}</span>
      </>
    );
  };

  render() {
    const header = (
      <>
        <div>
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={e => this.setState({ globalFilter: e.target.value })}
              placeholder="Pesquise pela descrição dos campos..."
              style={{ width: '50vw', height: '6vh' }}
            />
          </span>
        </div>
      </>
    );

    const pt = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
      dayNamesMin: ['DO', 'SE', 'TE', 'QA', 'QI', 'SX', 'SA'],
      monthNames: [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
      ],
      monthNamesShort: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez',
      ],
      today: 'Hoje',
      clear: 'Limpar',
      dateFormat: 'dd/mm/yy',
      weekHeader: 'Sm',
    };

    const dateInclusaoFilter = (
      <Calendar
        locale={pt}
        value={this.state.selectedDateInclusao}
        id="calendar-anotacao"
        onChange={e => {
          this.setState({ selectedDateInclusao: e.value });
          if (e.value === null) {
            this.dt.filter(null, 'dataInclusao', 'notEquals');
            return;
          }
          this.dt.filter(
            new Date(e.value).toISOString().substring(0, 10),
            'dataInclusao',
            'startsWith'
          );
        }}
        dateFormat="dd/mm/yy"
        className="p-column-filter"
        placeholder="Data"
        showButtonBar
      />
    );

    return (
      <>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <br />
            <Card>
              <CardBody className="card-body-0-padding">
                <div className="datatable">
                  <div className="card" id="tableAnotacao">
                    <DataTable
                      ref={el => (this.dt = el)}
                      value={this.state.anotacoes}
                      paginator
                      header={header}
                      globalFilter={this.state.globalFilter}
                      rows={5}
                      className="p-datatable-prime"
                      emptyMessage="Sem anotações"
                      loading={this.state.loading}
                      first={this.state.first}
                      onPage={e => {
                        this.setState({ first: e.first });
                        document.location.href = `${document.location.href.replace(
                          '#centroAnotacoes',
                          ''
                        )}#centroAnotacoes`;
                      }}
                      id="centroAnotacoes"
                    >
                      <Column
                        field="anotacao"
                        header="Anotação"
                        sortable
                        body={this.anotacaoBodyTemplate}
                        filter
                        filterPlaceholder="Anotação"
                        filterMatchMode="contains"
                        headerStyle={{ width: '15vw' }}
                      />
                      <Column
                        field="dataInclusao"
                        header="Data de Inclusão"
                        sortable
                        body={this.dataBodyTemplate}
                        filter
                        filterElement={dateInclusaoFilter}
                        filterFunction={() => this.filterDate()}
                        headerStyle={{ width: '10vw' }}
                      />
                    </DataTable>
                  </div>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </>
    );
  }
}

export default Anotacao;
